import { render, staticRenderFns } from "./PaymentGeteway.vue?vue&type=template&id=1e480f4b&scoped=true"
import script from "./PaymentGeteway.vue?vue&type=script&lang=js"
export * from "./PaymentGeteway.vue?vue&type=script&lang=js"
import style0 from "./PaymentGeteway.vue?vue&type=style&index=0&id=1e480f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e480f4b",
  null
  
)

export default component.exports